export default {
    props: {
        seriesDefaultsArea: {
            type: Object,
            kComposite: 'seriesDefaults.area'
        }, 
        seriesDefaultsBar: {
            type: Object,
            kComposite: 'seriesDefaults.bar'
        }, 
        seriesDefaultsBorderColor: {
            type: String,
            kComposite: 'seriesDefaults.border.color'
        }, 
        seriesDefaultsBorderDashType: {
            type: String,
            kComposite: 'seriesDefaults.border.dashType'
        }, 
        seriesDefaultsBorderWidth: {
            type: Number,
            kComposite: 'seriesDefaults.border.width'
        }, 
        seriesDefaultsBubble: {
            type: Object,
            kComposite: 'seriesDefaults.bubble'
        }, 
        seriesDefaultsCandlestick: {
            type: Object,
            kComposite: 'seriesDefaults.candlestick'
        }, 
        seriesDefaultsColumn: {
            type: Object,
            kComposite: 'seriesDefaults.column'
        }, 
        seriesDefaultsDonut: {
            type: Object,
            kComposite: 'seriesDefaults.donut'
        }, 
        seriesDefaultsGap: {
            type: Number,
            kComposite: 'seriesDefaults.gap'
        }, 
        seriesDefaultsLabelsBackground: {
            type: String,
            kComposite: 'seriesDefaults.labels.background'
        }, 
        seriesDefaultsLabelsBorderColor: {
            type: String,
            kComposite: 'seriesDefaults.labels.border.color'
        }, 
        seriesDefaultsLabelsBorderDashType: {
            type: String,
            kComposite: 'seriesDefaults.labels.border.dashType'
        }, 
        seriesDefaultsLabelsBorderWidth: {
            type: Number,
            kComposite: 'seriesDefaults.labels.border.width'
        }, 
        seriesDefaultsLabelsColor: {
            type: String,
            kComposite: 'seriesDefaults.labels.color'
        }, 
        seriesDefaultsLabelsFont: {
            type: String,
            kComposite: 'seriesDefaults.labels.font'
        }, 
        seriesDefaultsLabelsFormat: {
            type: String,
            kComposite: 'seriesDefaults.labels.format'
        }, 
        seriesDefaultsLabelsMargin: {
            type: Number,
            kComposite: 'seriesDefaults.labels.margin'
        }, 
        seriesDefaultsLabelsMarginBottom: {
            type: Number,
            kComposite: 'seriesDefaults.labels.margin.bottom'
        }, 
        seriesDefaultsLabelsMarginLeft: {
            type: Number,
            kComposite: 'seriesDefaults.labels.margin.left'
        }, 
        seriesDefaultsLabelsMarginRight: {
            type: Number,
            kComposite: 'seriesDefaults.labels.margin.right'
        }, 
        seriesDefaultsLabelsMarginTop: {
            type: Number,
            kComposite: 'seriesDefaults.labels.margin.top'
        }, 
        seriesDefaultsLabelsPadding: {
            type: Number,
            kComposite: 'seriesDefaults.labels.padding'
        }, 
        seriesDefaultsLabelsPaddingBottom: {
            type: Number,
            kComposite: 'seriesDefaults.labels.padding.bottom'
        }, 
        seriesDefaultsLabelsPaddingLeft: {
            type: Number,
            kComposite: 'seriesDefaults.labels.padding.left'
        }, 
        seriesDefaultsLabelsPaddingRight: {
            type: Number,
            kComposite: 'seriesDefaults.labels.padding.right'
        }, 
        seriesDefaultsLabelsPaddingTop: {
            type: Number,
            kComposite: 'seriesDefaults.labels.padding.top'
        }, 
        seriesDefaultsLabelsRotation: {
            type: String | Number,
            kComposite: 'seriesDefaults.labels.rotation'
        }, 
        seriesDefaultsLabelsTemplate: {
            type: String | Function,
            kComposite: 'seriesDefaults.labels.template'
        }, 
        seriesDefaultsLabelsVisible: {
            type: Boolean,
            kComposite: 'seriesDefaults.labels.visible'
        }, 
        seriesDefaultsLabelsVisual: {
            type: Function,
            kComposite: 'seriesDefaults.labels.visual'
        }, 
        seriesDefaultsLabelsFromBackground: {
            type: String,
            kComposite: 'seriesDefaults.labels.from.background'
        }, 
        seriesDefaultsLabelsFromBorderColor: {
            type: String,
            kComposite: 'seriesDefaults.labels.from.border.color'
        }, 
        seriesDefaultsLabelsFromBorderDashType: {
            type: String,
            kComposite: 'seriesDefaults.labels.from.border.dashType'
        }, 
        seriesDefaultsLabelsFromBorderWidth: {
            type: Number,
            kComposite: 'seriesDefaults.labels.from.border.width'
        }, 
        seriesDefaultsLabelsFromColor: {
            type: String,
            kComposite: 'seriesDefaults.labels.from.color'
        }, 
        seriesDefaultsLabelsFromFont: {
            type: String,
            kComposite: 'seriesDefaults.labels.from.font'
        }, 
        seriesDefaultsLabelsFromFormat: {
            type: String,
            kComposite: 'seriesDefaults.labels.from.format'
        }, 
        seriesDefaultsLabelsFromMargin: {
            type: Number,
            kComposite: 'seriesDefaults.labels.from.margin'
        }, 
        seriesDefaultsLabelsFromMarginBottom: {
            type: Number,
            kComposite: 'seriesDefaults.labels.from.margin.bottom'
        }, 
        seriesDefaultsLabelsFromMarginLeft: {
            type: Number,
            kComposite: 'seriesDefaults.labels.from.margin.left'
        }, 
        seriesDefaultsLabelsFromMarginRight: {
            type: Number,
            kComposite: 'seriesDefaults.labels.from.margin.right'
        }, 
        seriesDefaultsLabelsFromMarginTop: {
            type: Number,
            kComposite: 'seriesDefaults.labels.from.margin.top'
        }, 
        seriesDefaultsLabelsFromPadding: {
            type: Number,
            kComposite: 'seriesDefaults.labels.from.padding'
        }, 
        seriesDefaultsLabelsFromPaddingBottom: {
            type: Number,
            kComposite: 'seriesDefaults.labels.from.padding.bottom'
        }, 
        seriesDefaultsLabelsFromPaddingLeft: {
            type: Number,
            kComposite: 'seriesDefaults.labels.from.padding.left'
        }, 
        seriesDefaultsLabelsFromPaddingRight: {
            type: Number,
            kComposite: 'seriesDefaults.labels.from.padding.right'
        }, 
        seriesDefaultsLabelsFromPaddingTop: {
            type: Number,
            kComposite: 'seriesDefaults.labels.from.padding.top'
        }, 
        seriesDefaultsLabelsFromTemplate: {
            type: String | Function,
            kComposite: 'seriesDefaults.labels.from.template'
        }, 
        seriesDefaultsLabelsFromVisible: {
            type: Boolean,
            kComposite: 'seriesDefaults.labels.from.visible'
        }, 
        seriesDefaultsLabelsToBackground: {
            type: String,
            kComposite: 'seriesDefaults.labels.to.background'
        }, 
        seriesDefaultsLabelsToBorderColor: {
            type: String,
            kComposite: 'seriesDefaults.labels.to.border.color'
        }, 
        seriesDefaultsLabelsToBorderDashType: {
            type: String,
            kComposite: 'seriesDefaults.labels.to.border.dashType'
        }, 
        seriesDefaultsLabelsToBorderWidth: {
            type: Number,
            kComposite: 'seriesDefaults.labels.to.border.width'
        }, 
        seriesDefaultsLabelsToColor: {
            type: String,
            kComposite: 'seriesDefaults.labels.to.color'
        }, 
        seriesDefaultsLabelsToFont: {
            type: String,
            kComposite: 'seriesDefaults.labels.to.font'
        }, 
        seriesDefaultsLabelsToFormat: {
            type: String,
            kComposite: 'seriesDefaults.labels.to.format'
        }, 
        seriesDefaultsLabelsToMargin: {
            type: Number,
            kComposite: 'seriesDefaults.labels.to.margin'
        }, 
        seriesDefaultsLabelsToMarginBottom: {
            type: Number,
            kComposite: 'seriesDefaults.labels.to.margin.bottom'
        }, 
        seriesDefaultsLabelsToMarginLeft: {
            type: Number,
            kComposite: 'seriesDefaults.labels.to.margin.left'
        }, 
        seriesDefaultsLabelsToMarginRight: {
            type: Number,
            kComposite: 'seriesDefaults.labels.to.margin.right'
        }, 
        seriesDefaultsLabelsToMarginTop: {
            type: Number,
            kComposite: 'seriesDefaults.labels.to.margin.top'
        }, 
        seriesDefaultsLabelsToPadding: {
            type: Number,
            kComposite: 'seriesDefaults.labels.to.padding'
        }, 
        seriesDefaultsLabelsToPaddingBottom: {
            type: Number,
            kComposite: 'seriesDefaults.labels.to.padding.bottom'
        }, 
        seriesDefaultsLabelsToPaddingLeft: {
            type: Number,
            kComposite: 'seriesDefaults.labels.to.padding.left'
        }, 
        seriesDefaultsLabelsToPaddingRight: {
            type: Number,
            kComposite: 'seriesDefaults.labels.to.padding.right'
        }, 
        seriesDefaultsLabelsToPaddingTop: {
            type: Number,
            kComposite: 'seriesDefaults.labels.to.padding.top'
        }, 
        seriesDefaultsLabelsToTemplate: {
            type: String | Function,
            kComposite: 'seriesDefaults.labels.to.template'
        }, 
        seriesDefaultsLabelsToVisible: {
            type: Boolean,
            kComposite: 'seriesDefaults.labels.to.visible'
        }, 
        seriesDefaultsLine: {
            type: Object,
            kComposite: 'seriesDefaults.line'
        }, 
        seriesDefaultsOhlc: {
            type: Object,
            kComposite: 'seriesDefaults.ohlc'
        }, 
        seriesDefaultsOverlayGradient: {
            type: String,
            kComposite: 'seriesDefaults.overlay.gradient'
        }, 
        seriesDefaultsPie: {
            type: Object,
            kComposite: 'seriesDefaults.pie'
        }, 
        seriesDefaultsRangeArea: {
            type: Object,
            kComposite: 'seriesDefaults.rangeArea'
        }, 
        seriesDefaultsScatter: {
            type: Object,
            kComposite: 'seriesDefaults.scatter'
        }, 
        seriesDefaultsScatterLine: {
            type: Object,
            kComposite: 'seriesDefaults.scatterLine'
        }, 
        seriesDefaultsSpacing: {
            type: Number,
            kComposite: 'seriesDefaults.spacing'
        }, 
        seriesDefaultsStack: {
            type: Boolean,
            kComposite: 'seriesDefaults.stack'
        }, 
        seriesDefaultsStackType: {
            type: String,
            kComposite: 'seriesDefaults.stack.type'
        }, 
        seriesDefaultsType: {
            type: String,
            kComposite: 'seriesDefaults.type'
        }, 
        seriesDefaultsTooltipBackground: {
            type: String,
            kComposite: 'seriesDefaults.tooltip.background'
        }, 
        seriesDefaultsTooltipBorderColor: {
            type: String,
            kComposite: 'seriesDefaults.tooltip.border.color'
        }, 
        seriesDefaultsTooltipBorderWidth: {
            type: Number,
            kComposite: 'seriesDefaults.tooltip.border.width'
        }, 
        seriesDefaultsTooltipColor: {
            type: String,
            kComposite: 'seriesDefaults.tooltip.color'
        }, 
        seriesDefaultsTooltipFont: {
            type: String,
            kComposite: 'seriesDefaults.tooltip.font'
        }, 
        seriesDefaultsTooltipFormat: {
            type: String,
            kComposite: 'seriesDefaults.tooltip.format'
        }, 
        seriesDefaultsTooltipPadding: {
            type: Number,
            kComposite: 'seriesDefaults.tooltip.padding'
        }, 
        seriesDefaultsTooltipPaddingBottom: {
            type: Number,
            kComposite: 'seriesDefaults.tooltip.padding.bottom'
        }, 
        seriesDefaultsTooltipPaddingLeft: {
            type: Number,
            kComposite: 'seriesDefaults.tooltip.padding.left'
        }, 
        seriesDefaultsTooltipPaddingRight: {
            type: Number,
            kComposite: 'seriesDefaults.tooltip.padding.right'
        }, 
        seriesDefaultsTooltipPaddingTop: {
            type: Number,
            kComposite: 'seriesDefaults.tooltip.padding.top'
        }, 
        seriesDefaultsTooltipTemplate: {
            type: String | Function,
            kComposite: 'seriesDefaults.tooltip.template'
        }, 
        seriesDefaultsTooltipVisible: {
            type: Boolean,
            kComposite: 'seriesDefaults.tooltip.visible'
        }, 
        seriesDefaultsVerticalArea: {
            type: Object,
            kComposite: 'seriesDefaults.verticalArea'
        }, 
        seriesDefaultsVerticalLine: {
            type: Object,
            kComposite: 'seriesDefaults.verticalLine'
        }, 
        seriesDefaultsVerticalRangeArea: {
            type: Object,
            kComposite: 'seriesDefaults.verticalRangeArea'
        }, 
        seriesDefaultsVisual: {
            type: Function,
            kComposite: 'seriesDefaults.visual'
        }, 
        seriesDefaultsNotesIconBackground: {
            type: String,
            kComposite: 'seriesDefaults.notes.icon.background'
        }, 
        seriesDefaultsNotesIconBorderColor: {
            type: String,
            kComposite: 'seriesDefaults.notes.icon.border.color'
        }, 
        seriesDefaultsNotesIconBorderWidth: {
            type: Number,
            kComposite: 'seriesDefaults.notes.icon.border.width'
        }, 
        seriesDefaultsNotesIconSize: {
            type: Number,
            kComposite: 'seriesDefaults.notes.icon.size'
        }, 
        seriesDefaultsNotesIconType: {
            type: String,
            kComposite: 'seriesDefaults.notes.icon.type'
        }, 
        seriesDefaultsNotesIconVisible: {
            type: Boolean,
            kComposite: 'seriesDefaults.notes.icon.visible'
        }, 
        seriesDefaultsNotesLabelBackground: {
            type: String,
            kComposite: 'seriesDefaults.notes.label.background'
        }, 
        seriesDefaultsNotesLabelBorderColor: {
            type: String,
            kComposite: 'seriesDefaults.notes.label.border.color'
        }, 
        seriesDefaultsNotesLabelBorderDashType: {
            type: String,
            kComposite: 'seriesDefaults.notes.label.border.dashType'
        }, 
        seriesDefaultsNotesLabelBorderWidth: {
            type: Number,
            kComposite: 'seriesDefaults.notes.label.border.width'
        }, 
        seriesDefaultsNotesLabelColor: {
            type: String,
            kComposite: 'seriesDefaults.notes.label.color'
        }, 
        seriesDefaultsNotesLabelFont: {
            type: String,
            kComposite: 'seriesDefaults.notes.label.font'
        }, 
        seriesDefaultsNotesLabelTemplate: {
            type: String | Function,
            kComposite: 'seriesDefaults.notes.label.template'
        }, 
        seriesDefaultsNotesLabelVisible: {
            type: Boolean,
            kComposite: 'seriesDefaults.notes.label.visible'
        }, 
        seriesDefaultsNotesLabelRotation: {
            type: Number,
            kComposite: 'seriesDefaults.notes.label.rotation'
        }, 
        seriesDefaultsNotesLabelFormat: {
            type: String,
            kComposite: 'seriesDefaults.notes.label.format'
        }, 
        seriesDefaultsNotesLabelPosition: {
            type: String,
            kComposite: 'seriesDefaults.notes.label.position'
        }, 
        seriesDefaultsNotesLineDashType: {
            type: String,
            kComposite: 'seriesDefaults.notes.line.dashType'
        }, 
        seriesDefaultsNotesLineWidth: {
            type: Number,
            kComposite: 'seriesDefaults.notes.line.width'
        }, 
        seriesDefaultsNotesLineColor: {
            type: String,
            kComposite: 'seriesDefaults.notes.line.color'
        }, 
        seriesDefaultsNotesLineLength: {
            type: Number,
            kComposite: 'seriesDefaults.notes.line.length'
        }, 
        seriesDefaultsNotesVisual: {
            type: Function,
            kComposite: 'seriesDefaults.notes.visual'
        },
        seriesDefaultsDynamicSlope: {
            type: Boolean,
            kComposite: 'seriesDefaults.dynamicSlope'
        },
        seriesDefaultsDynamicHeight: {
            type: Boolean,
            kComposite: 'seriesDefaults.dynamicHeight'
        },
        seriesDefaultsStartAngle: {
            type: Number,
            kComposite: 'seriesDefaults.startAngle'
        },
        seriesDefaultsStyle: {
            type: String,
            kComposite: 'seriesDefaults.style'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/SeriesDefaults.js